"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExBudget = void 0;
var cbor_1 = require("@harmoniclabs/cbor");
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var ExBudget = /** @class */ (function () {
    function ExBudget(args_or_cpu, mem) {
        if (typeof args_or_cpu === "object") {
            this._cpu = BigInt(args_or_cpu.cpu);
            this._mem = BigInt(args_or_cpu.mem);
        }
        else {
            this._cpu = BigInt(args_or_cpu);
            if (mem === undefined) {
                throw new Error('missing "mem" paramter while cosntructing "ExBudget" instance');
            }
            this._mem = BigInt(mem);
        }
    }
    Object.defineProperty(ExBudget.prototype, "cpu", {
        get: function () { return this._cpu; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExBudget.prototype, "mem", {
        get: function () { return this._mem; },
        enumerable: false,
        configurable: true
    });
    ExBudget.prototype.add = function (other) {
        this._cpu = this._cpu + BigInt(other.cpu);
        this._mem = this._mem + BigInt(other.mem);
    };
    ExBudget.prototype.sub = function (other) {
        this._cpu = this._cpu - BigInt(other.cpu);
        this._mem = this._mem - BigInt(other.mem);
    };
    ExBudget.add = function (a, b) {
        return new ExBudget(a.cpu + b.cpu, a.mem + b.mem);
    };
    ExBudget.sub = function (a, b) {
        var cpu = a.cpu - b.cpu;
        var mem = a.mem - b.mem;
        return new ExBudget(cpu, mem);
    };
    Object.defineProperty(ExBudget, "default", {
        get: function () {
            return new ExBudget(10000000000, // cpu
            14000000 // mem
            );
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ExBudget, "maxCborSize", {
        get: function () {
            var max_uint64 = (BigInt(1) << BigInt(64)) - BigInt(1);
            return new ExBudget(max_uint64, // cpu
            max_uint64 // mem
            );
        },
        enumerable: false,
        configurable: true
    });
    ExBudget.prototype.clone = function () {
        return new ExBudget(this.cpu, this.mem);
    };
    ExBudget.prototype.toCbor = function () {
        return cbor_1.Cbor.encode(this.toCborObj());
    };
    ExBudget.prototype.toCborObj = function () {
        return new cbor_1.CborArray([
            new cbor_1.CborUInt(this.mem),
            new cbor_1.CborUInt(this.cpu)
        ]);
    };
    ExBudget.fromCbor = function (cStr) {
        return ExBudget.fromCborObj(cbor_1.Cbor.parse((0, cbor_1.forceCborString)(cStr)));
    };
    ExBudget.fromCborObj = function (cObj) {
        if (!(cObj instanceof cbor_1.CborArray &&
            cObj.array[0] instanceof cbor_1.CborUInt &&
            cObj.array[1] instanceof cbor_1.CborUInt))
            throw new Error("Invalid CBOR format for \"ExBudget\"");
        return new ExBudget({
            mem: cObj.array[0].num,
            cpu: cObj.array[1].num,
        });
    };
    ExBudget.prototype.toJson = function () {
        return {
            steps: this.cpu.toString(),
            memory: this.mem.toString()
        };
    };
    /** standard interface for `JSON.stringify` */
    ExBudget.prototype.toJSON = function () {
        return this.toJson();
    };
    ExBudget.fromJson = function (stuff) {
        return new ExBudget({
            mem: stuff.memory,
            cpu: stuff.steps,
        });
    };
    ExBudget.isJson = function (stuff) {
        return ((0, obj_utils_1.isObject)(stuff) &&
            typeof stuff.memory === "number" &&
            typeof stuff.steps === "number");
    };
    return ExBudget;
}());
exports.ExBudget = ExBudget;
